import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
import { StorageUsage } from '../../../../@core/lidar/domain/entities/StorageUsage'
import ProgressBar from '../../../../components/ui/progressBar/ProgressBar.vue'
import StorageRequestDialog from './StorageRequestDialog.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'StorageUsageBanner',
  props: {
    usage: null
  },
  emits: ["requestStorage"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'requestStorage'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	usage: StorageUsage
};





const showDialog = ref(false)

const isStorageCritical = computed(() => props.usage.usedPercent >= 90)

const progressBarColor = computed(() => (isStorageCritical.value ? '#C60020' : undefined))

const usageText = computed(() => {
	if (props.usage.usedPercent === 100) {
		return 'Você não possui armazenamento disponível para upload das imagens.'
	}

	return `Você possui ${props.usage.availableGbs.toFixed(2)}GB de armazenamento disponível
para upload das imagens. `
})

return { __sfc: true,props, emit, showDialog, isStorageCritical, progressBarColor, usageText, ProgressBar, StorageRequestDialog }
}

})